module.exports = __webpack_public_path__ + "static/media/research-3.a81e5c77.svg";